import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
} from '@angular/core';

import {
  TableBuilderFactory,
  TableComponent,
  TableConfig,
  TableDataPayload,
} from '@web/shared/ui';
import { Observable, of } from 'rxjs';
import { OrderRefundCollectionItem } from '@web/shared/module/shop';
import { AdminOrderRefundListCustomCellTemplateComponent } from '../../components/admin-order-refund-list-custom-cell-template/admin-order-refund-list-custom-cell-template.component';

@Component({
  selector: 'app-admin-order-refund-list',
  imports: [TableComponent, AdminOrderRefundListCustomCellTemplateComponent],
  templateUrl: './admin-order-refund-list.component.html',
  styleUrl: './admin-order-refund-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminOrderRefundListComponent implements OnInit {
  public readonly refunds = input.required<OrderRefundCollectionItem[]>();

  /* prettier-ignore */
  protected config!: TableConfig<OrderRefundCollectionItem>;

  /* prettier-ignore */
  private readonly builder = inject(TableBuilderFactory<OrderRefundCollectionItem>).create();

  public ngOnInit(): void {
    this.buildTable();
  }

  /* prettier-ignore */
  private buildTable(): void {
    this.config = this.builder
      .dataKey('number')
      .pagination(false)
      .filtering(false)
      .columns((builder) => [
        builder //
          .initText('number')
          .width('14rem')
          .label('Numer zwrotu')
          .build(),

        builder //
          .initCustom('status')
          .width('10rem')
          .label('Status')
          .build(),

        builder //
          .initCustom('type')
          .width('10rem')
          .label('Rodzaj')
          .build(),

        builder //
          .initCustom('invoiceNumber')
          .width('12rem')
          .label('Korekta faktury')
          .build(),

        builder //
          .initText('description')
          .width('24rem')
          .label('Opis')
          .build(),

        builder //
          .initCurrency('refundedPrice')
          .width('10rem')
          .label('Kwota zwrotu')
          .build(),

        builder //
          .initDate('createdAt')
          .width('12rem')
          .label('Data utworzenia')
          .build(),

        builder //
          .initDate('finalizedAt')
          .width('12rem')
          .label('Data zatwierdzenia')
          .build(),

        builder //
          .initDate('cancelledAt')
          .width('12rem')
          .label('Data anulowania')
          .build(),
      ])
      .dataSource({
        fetch: (): Observable<TableDataPayload<OrderRefundCollectionItem>> =>
          of(new TableDataPayload(this.refunds(), this.refunds().length, 1, this.refunds().length)),
      })
      .build();
  }
}
